import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux';
import Navbar from '../Header/Navbar'
import NavbarSecond from '../Header/NavbarSecond'
import MobileNavbar from '../Header/MobileNavbar'
import Footer from '../Footer/Footer'
import HelpAndSupportBanner from './HelpAndSupportBanner/HelpAndSupportBanner'
import HelpAndSupportContent from './HelpAndSupportContent/HelpAndSupportContent'
import { getAllBannerData } from '../../Redux/Action/Action';

const HelpAndSupportPage = () => {

    const dispatch = useDispatch();

    useEffect(() => {

        dispatch(getAllBannerData());

    }, []);

    const bannerData = useSelector((state) => (state?.Reducer) ? (state?.Reducer?.allBannerDataList?.data?.[0]) : []);


    return (
        <>
            <Navbar />
            <NavbarSecond />
            <MobileNavbar />
            <HelpAndSupportBanner bannerData={bannerData} />
            <HelpAndSupportContent />
            <Footer />
        </>
    )
}

export default HelpAndSupportPage